module.exports = __webpack_public_path__ + "img/user.d5a02584.png";